import { render, staticRenderFns } from "./ChannelCustomBrand.vue?vue&type=template&id=12feb9c2"
import script from "./ChannelCustomBrand.vue?vue&type=script&lang=js"
export * from "./ChannelCustomBrand.vue?vue&type=script&lang=js"
import style0 from "./ChannelCustomBrand.vue?vue&type=style&index=0&id=12feb9c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports